import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { UserPermission } from '../models/user-permission.model';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class AuthenticationHttpService {
  private readonly loginURL: string = this.environment.baseUrl + '/api/auth/login';
  private readonly permissionURL: string = this.environment.baseUrl + '/api/auth/permissions';

  constructor(private http: Http,
              private environment: EnvironmentConfiguration) {
  }

  login(username: string, password: string): Observable<UserPermission> {
    const loginPayload = { 'userId': username, 'password': password };

    return this.http.post(this.loginURL, loginPayload)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getPermissions(token: string): Observable<UserPermission> {
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': token
    });

    let options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.get(this.permissionURL, options)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/services/authentication.http.service.ts